<template lang="pug">
  .solicitud
    b-alert(:show='true' v-if="this.mensaje != ''" :variant='tipo')
      | {{mensaje}}
    b-form(@submit='onSubmit' @reset='onReset')

      b-card()
        template(#header='')
          h6.mb-0 Modificar Solicitud de Información
        b-card-text
          b-tabs(pills='' content-class='mt-3')
            b-tab(title='Modificar')
              div
                form.px-2
                  .form-group.row
                    b-form-group#input-group-0.col-sm-3.col-form-label(label='Fecha:' label-for='input-fecha')
                    .col-sm-5
                      b-form-input(v-model='this.solicitudInformacion.fecha_alta.slice(0, 10)' :disabled='true' type="date")
                    b-form-group#input-group-numero.col-sm-1.col-form-label(label='Numero:' label-for='input-fecha')
                    .col-sm-1
                      b-form-input(v-model='solicitudInformacion.numero' :disabled='true')
                  .form-group.row
                    b-form-group#input-group-2.col-sm-3.col-form-label(label='Estado:' label-for='input-tipo')
                    .col-sm-7
                      b-form-select(v-model='solicitudInformacion.estado_codigo' :disabled='true' :options='estadoRfiList' value-field="codigo" text-field="descripcion")
                  .form-group.row
                    span(style='color: red;') *
                    b-form-group#input-group-1.col-sm-3.col-form-label(label='Tema:' label-for='input-tema')
                    .col-sm-7
                      b-form-input#input-tema(v-model='solicitudInformacion.tema' :disabled='this.disableFecha'  placeholder='Tema')
                  .form-group.row
                    span(style='color: red;') *
                    b-form-group#input-group-3.col-sm-3.col-form-label(label='Descripcion:' label-for='input-descripcion')
                    .col-sm-7
                      b-form-textarea#input-descripcion(v-model='solicitudInformacion.descripcion' :disabled='this.disableFecha' placeholder='Descripcion' rows ="5")
                  .form-group.row
                    span(style='color: red;') *
                    b-form-group#input-group-2.col-sm-3.col-form-label(label='Tipo de Solicitud de Informacion:' label-for='input-tipo')
                    .col-sm-7
                      b-form-select(v-model='solicitudInformacion.tipo_rfi_codigo' :options='tipoRfiList' :disabled='this.disableFecha' value-field="codigo" text-field="descripcion")
                  .form-group.row
                    span(style='color: red;') *
                    b-form-group#input-group-4.col-sm-3.col-form-label(label='Fecha Fin de Recepcion de Respuestas:' label-for='input-fecha-fin-recepcion')
                    .col-sm-3
                      b-form-input#input-fecha-fin-recepcion(v-model='solicitudInformacion.recepcion_propuesta_fecha_fin' :disabled='this.disableFecha' type="date")
                    span(style='color: red;') *
                    b-form-group#input-group-6.col-sm-2.col-form-label(label='Hora Fin de Recepcion:' label-for='input-hora-recepcion' hide-header = '')
                    .col-sm-2
                      b-form-input#input-hora-recepcion.col-form-label(v-model='solicitudInformacion.recepcion_propuesta_hora_fin' :disabled='this.disableFecha' type="time" required='')

                  .form-group.row
                    b-form-group#input-group-6.col-sm-3.col-form-label(label='Fecha de Reunion Informativa:' label-for='input-fecha-reunion')
                    .col-sm-3
                      b-form-input#input-fecha-reunion(v-model='solicitudInformacion.reunion_informativa_fecha' :disabled='this.disableFecha' type="date")
                    b-form-group#input-group-6.col-sm-2.col-form-label(label='Hora Reunion Informativa:' label-for='input-hora-reunion' hide-header = '')
                    .col-sm-2
                      b-form-input#input-hora-reunion.col-form-label(v-model='solicitudInformacion.reunion_informativa_hora' :disabled='this.disableFecha' type="time")
                  .form-group.row
                    b-form-group#input-group-7.col-sm-3.col-form-label(label='Lugar o Link de Reunion Informativa:'  label-for='input-lugar-reunion')
                    .col-sm-7
                      b-form-input#input-lugar-reunion(v-model='solicitudInformacion.reunion_informativa_lugar' :disabled='this.disableFecha' placeholder='Lugar de Reunion Informativa')

                  .form-group
                    div(v-if="this.contactoModal == false")
                      button.btn.btn-primary.m-1(@click.prevent='agregarContacto()' v-if="!disableFecha") Agregar Contactos
                      .card.table-panel(id='')
                        .card-header
                          h3.card-title
                            | Contactos
                        .card-body.table-responsive
                          table.table.table-bordered.table-condensed.table-striped.table-hover
                            thead
                              tr
                                th.text-center.w-25 Nombre
                                th.text-center.w-25 Cargo
                                th.text-center.w-25 Correo Electronico
                                th.text-center.w-25 Telefono
                                th.text-center.w-auto(v-if="!disableFecha") Acciones
                            tbody()

                              tr( v-for='(row,index) in listaContactos')
                                td.text-center  {{row.nombre}}
                                td.text-center {{row.cargo}}
                                td.text-center {{row.correo_electronico}}
                                td.text-center {{row.telefono}}
                                td(v-if="!disableFecha")
                                  .btn-group
                                    b-dropdown.m-md-1(text='Acciones' )
                                      b-dropdown-item(@click.prevent='modificarContacto(row,index)') Modificar
                                      b-dropdown-item(@click.prevent='borrarContacto(row,index)') Borrar

                    b-form(@submit='onSubmitContacto' @reset='onResetContacto')
                      b-card(v-if="this.contactoModal == true")
                        template(#header='')
                          h6.mb-0 Agregar Contacto
                        b-card-text
                          div
                            .form-group.row
                              span(style='color: red;') *
                              b-form-group#input-group-1.col-sm-2.col-form-label(label='Nombre:' label-for='input-nombre')
                              .col-sm-7
                                b-form-input#input-nombre(v-model='contacto.nombre' required='')
                            .form-group.row
                              span(style='color: red;') *
                              b-form-group#input-group-2.col-sm-2.col-form-label(label='Cargo:' label-for='input-cargo')
                              .col-sm-7
                                b-form-input#input-cargo(v-model='contacto.cargo' required='')
                            .form-group.row
                              span(style='color: red;') *
                              b-form-group#input-group-3.col-sm-2.col-form-label(label='Correo:' label-for='input-correo')
                              .col-sm-7
                                b-form-input#input-correo(v-model='contacto.correo_electronico' type='email' required='')
                            .form-group.row
                              span(style='color: red;') *
                              b-form-group#input-group-3.col-sm-2.col-form-label(label='Telefono:' label-for='input-telefono')
                              .col-sm-7
                                b-form-input#input-telefono(v-model='contacto.telefono' required='' )

                            div.float-right
                              button.btn.btn-primary.m-1(type='reset' variant='danger') Volver
                            button.btn.btn-primary.m-1(type='submit' variant='primary') Guardar Contacto


                  .form-group.row(v-if="!this.disableFecha")
                    b-form-group#input-group-12.col-sm-3.col-form-label(label='Adjuntar Documentos' label-for='input-documento')
                    .col-sm
                      .row
                        .col
                          b-form-file#file-default(
                            v-model= 'archivo'
                            placeholder="Seleccionar Archivo"
                            accept=".zip, .rar, .tar, application/pdf,application/x-zip-compressed"
                            )
                        .col
                          button.btn.btn-primary.border-top(
                            :disabled='this.archivo == null || cargaArchivo'
                            @click.prevent='cargarArchivo()'
                          ) {{cargaArchivo ? 'Subiendo Archivo...' : 'Subir Archivo'}}

                table.table.table-bordered.table-condensed.table-striped.table-hover(v-if = 'archivoList.length > 0')
                  thead
                    tr
                      th.text-center.w-25 Nombre
                      th.text-center.w-25 Fecha Adjunto
                      th.text-center.w-25 Fecha Publicacion
                      th.text-center.w-25 Acciones
                  tbody()
                    tr( v-for='(row,index) in archivoList')
                      td.text-center {{row.nombre_archivo}}
                      td.text-center {{row.fecha_archivo}}
                      td.text-center
                      td.text-center
                        .btn-group
                          b-dropdown.m-md-1(text='Acciones')
                            b-dropdown-item(@click.prevent='obtenerArchivo(row)') Descargar
                            b-dropdown-item(@click.prevent='borrarArchivo(row)' v-if="!disableFecha" ) Borrar

                div.float-right
                  button.btn.btn-danger.m-1(type='submit'  @click='publicar = false' variant='primary' v-if="!disableFecha") Modificar
                  button.btn.btn-danger.m-1(type='submit'  @click='publicar = true' variant='primary' v-if="!disableFecha") Publicar

                //button.btn.btn-primary.m-1(@click.prevent='volver()') Volver
                button.btn.btn-primary.m-1(type='reset' variant='danger') Volver

            b-tab(title='Invitados')
              Invitados(:rfi_id = 'this.id' :edit = 'puedeModificarInvitado')

    modal(:title="modalTitulo" :texto="modalTexto"
      :modalShow="modalShow"
      :button-action-name="modalBoton"
      @confirmed='confirmarAccionModal()'
      @close="modalShow = !modalShow"
    )

</template>


<script>

import {HTTP} from '../http';
import Invitados from "../components/Invitados";
import functions from "../mixins/functions";
import moment from 'moment'
import Modal from "../components/Modal"

export default {
  name: "SolicitudInformacionCrearModificar",
  components: {
    Invitados,
    Modal
  },
  mixins: [functions],

  data() {
    return {
      id: null,
      solicitudInformacion: {},
      estadoRfiList: {},
      selected: null,
      tipoRfiList: [ ],
      date: null,
      archivoList: [],
      listaPropuestas: [],
      archivo: null,
      cargaArchivo: false,
      contacto: {},
      listaContactos: [],
      contactoModal: false,
      indexModificado: null,
      fechaRecepcionOld: null,
      disableFecha: false,
      publicar: false,
      puedeModificarInvitado: true,
      modalShow: false,
      modalTitulo: "",
      modalTexto: "",
      modalBoton: "",
      mensaje: "",
      tipo: "",
      requiredFieldsContacto: [
        'cargo','correo_electronico'
      ]
    }
  },
  async created(){
    try {
      window.scrollTo(0,0);
      this.id = this.$route.query.id;
      this.solicitudInformacion = (await HTTP.get('/solicitudInformacion/',{ params: {solicitudId: this.id}})).data
      this.listaContactos = (await HTTP.get('/solicitudInformacion/contacto/listar/',{ params: {solicitudId: this.id}})).data
      this.estadoRfiList = (await HTTP.get('/selectores/parametros', { params: {dominio: "RFI_ESTADO"}})).data.list;
      this.tipoRfiList = (await HTTP.get('/selectores/parametros', { params: {dominio: "RFI_TIPO_SOLICITUD_INFORMACION"}})).data.list;
      this.date=this.concatDateTime(new Date().toISOString().slice(0, 10),new Date().toLocaleTimeString('en-GB'));
      this.fechaRecepcionOld = this.solicitudInformacion.recepcion_propuesta_fecha_fin;
      this.separarFechaHora()
      await this.getArchivos();

      if(this.solicitudInformacion.tiene_borrador){
        this.tipo = 'warning'
        this.mensaje = "Esta Solicitud de Informacion cuenta con datos modificados pendientes de publicacion. Por favor, vuelva a publicar."
      }


      if(this.date>this.concatDateTime(this.solicitudInformacion.recepcion_propuesta_fecha_fin,this.solicitudInformacion.recepcion_propuesta_hora_fin)
          || this.solicitudInformacion.estado_codigo == "CANCELADO" || this.solicitudInformacion.estado_codigo == "ELIMINADO"){
        this.disableFecha = true;
        this.puedeModificarInvitado = false;
        if(this.date>this.solicitudInformacion.recepcion_propuesta_fecha_fin){
          this.tipo = 'warning'
          this.mensaje = "Esta Solicitud de Informacion no puede ser modificada debido a que ya paso su fecha tope de modificacion."
        } else if(this.solicitudInformacion.estado_codigo == "CANCELADO" || this.solicitudInformacion.estado_codigo == "ELIMINADO"){
          this.tipo = 'warning'
          this.mensaje = "Esta Solicitud de Informacion no puede ser modificada debido a que ya fue cancelada o eliminada."
        }
      }

      this.listaPropuestas = (await HTTP.get('/respuesta/list/',{ params: {solicitudId: this.id}})).data
      if(this.listaPropuestas.length>0 ){
        this.disableFecha = true;
        this.puedeModificarInvitado = false;
        this.tipo = 'warning'
        this.mensaje = "Esta Solicitud de Informacion no puede ser modificada debido a que ya tiene respuestas presentadas."
      }
    }catch (error) {
      console.log(error)
    }


    //this.desactiveSpinner();
  },

  methods:{

    onSubmit(event) {
      let fechaTope = new Date();
      fechaTope.setDate(fechaTope.getDate() + 2)
      fechaTope = this.concatDateTime(fechaTope.toISOString().slice(0, 10),fechaTope.toLocaleTimeString('en-GB'));
      console.log(fechaTope)
      console.log(this.publicar)
      console.log(this.concatDateTime(this.solicitudInformacion.recepcion_propuesta_fecha_fin,this.solicitudInformacion.recepcion_propuesta_hora_fin))


      if(this.solicitudInformacion.reunion_informativa_lugar === "" || this.solicitudInformacion.reunion_informativa_lugar == null)
        this.solicitudInformacion.reunion_informativa_lugar = undefined
      if(this.publicar &&
          fechaTope > this.concatDateTime(this.solicitudInformacion.recepcion_propuesta_fecha_fin,this.solicitudInformacion.recepcion_propuesta_hora_fin)){
        window.scrollTo(0, 0);
        this.$root.$emit('showNotificationWarning', {mensaje: 'No es posible publicar el RFI, sin un plazo minimo de 2(dos) dias para presentar respuestas.'});
        event.preventDefault()
      }else if(this.fechaRecepcionOld>this.concatDateTime(this.solicitudInformacion.recepcion_propuesta_fecha_fin,this.solicitudInformacion.recepcion_propuesta_hora_fin)) {
        window.scrollTo(0, 0);
        this.$root.$emit('showNotificationWarning', {mensaje: 'No se puede volver atras la fecha de Recepcion de Respuestas'});
        event.preventDefault()
      }else if(!isNaN(new Date(this.solicitudInformacion.reunion_informativa_fecha)) && this.concatDateTime(this.solicitudInformacion.recepcion_propuesta_fecha_fin,this.solicitudInformacion.recepcion_propuesta_hora_fin) <
          this.concatDateTime(this.solicitudInformacion.reunion_informativa_fecha,this.solicitudInformacion.reunion_informativa_hora)){
        window.scrollTo(0, 0);
        this.$root.$emit('showNotificationWarning', {mensaje: 'La fecha de la Reunion Informativa no puede ser mayor a la fecha de Recepcion de Respuestas'});
        event.preventDefault()
        //controla si la fecha de recepcion de respuestas es menor al dia de hoy
      }else if(this.concatDateTime(this.solicitudInformacion.recepcion_propuesta_fecha_fin,this.solicitudInformacion.recepcion_propuesta_hora_fin) <
          this.concatDateTime(new Date().toISOString().slice(0, 10),new Date().toLocaleTimeString('en-GB'))){
        window.scrollTo(0, 0);
        this.$root.$emit('showNotificationWarning', {mensaje: 'La fecha de Recepcion de Respuestas no puede ser menor al dia de hoy'});
        event.preventDefault()
        //controla si la fecha de reunion informativa es menor al dia de hoy
      }else if(this.concatDateTime(this.solicitudInformacion.reunion_informativa_fecha,this.solicitudInformacion.reunion_informativa_hora) <
          this.concatDateTime(new Date().toISOString().slice(0, 10),new Date().toLocaleTimeString('en-GB'))){
        window.scrollTo(0, 0);
        this.$root.$emit('showNotificationWarning', {mensaje: 'La fecha de la Reunion Informativa no puede ser menor al dia de hoy'});
        event.preventDefault()
      }else if((typeof(this.solicitudInformacion.reunion_informativa_lugar) !== 'undefined'
              && isNaN(new Date(this.solicitudInformacion.reunion_informativa_fecha))) ||
          typeof(this.solicitudInformacion.reunion_informativa_lugar) === 'undefined'
          && !isNaN(new Date(this.solicitudInformacion.reunion_informativa_fecha))){

        window.scrollTo(0, 0);
        this.$root.$emit('showNotificationWarning', {mensaje: 'Debe ingresar la fecha y lugar de la Reunion informativa'});
        event.preventDefault()
      }else if((typeof(this.solicitudInformacion.reunion_informativa_lugar) !== 'undefined'
              && isNaN(new Date(this.solicitudInformacion.reunion_informativa_fecha))) ||
          typeof(this.solicitudInformacion.reunion_informativa_lugar) === 'undefined'
          && !isNaN(new Date(this.solicitudInformacion.reunion_informativa_fecha))){

          window.scrollTo(0, 0);
          this.$root.$emit('showNotificationWarning', {mensaje: 'Debe ingresar la fecha y lugar de la Reunion informativa'});
          event.preventDefault()
      }else if(this.publicar && this.archivoList.length == 0){
        window.scrollTo(0, 0);
        this.$root.$emit('showNotificationWarning', {mensaje: 'No se puede publicar una Solicitud de Informacion sin documentos adjuntos'});
        event.preventDefault()
      }else{
        if(this.publicar == true){
          this.mostrarModal("publicar")
        }else if(this.publicar == false) {
          this.mostrarModal("modificar")
        }
        event.preventDefault()
      }
    },
    onReset(event) {
      this.volver();
      event.preventDefault()
      // Trick to reset/clear native browser form validation state

    },

    onSubmitContacto(event) {
      console.log(this.contacto);
      event.preventDefault();
      this.grabarContacto(this.contacto)
    },
    onResetContacto(event) {
      event.preventDefault()
      this.contacto = {};
      this.indexModificado = null ;
      this.contactoModal = false;
    },

    separarFechaHora(){
      this.solicitudInformacion.recepcion_propuesta_hora_fin =moment(String(this.solicitudInformacion.recepcion_propuesta_fecha_fin)).format('HH:mm')
      this.solicitudInformacion.recepcion_propuesta_fecha_fin =moment(String(this.solicitudInformacion.recepcion_propuesta_fecha_fin)).format('YYYY-MM-DD')

      this.solicitudInformacion.reunion_informativa_hora =moment(String(this.solicitudInformacion.reunion_informativa_fecha)).format('HH:mm:ss')
      this.solicitudInformacion.reunion_informativa_fecha =moment(String(this.solicitudInformacion.reunion_informativa_fecha)).format('YYYY-MM-DD')
    },

    mostrarModal(accion){
      window.scrollTo(0,0);
      this.modalShow = !this.modalShow
      if(accion =="publicar"){
        this.modalTexto = "Desea publicar la Solicitud de Informacion?"
        this.modalTitulo = "Confirmar publicacion de la Solicitud"
        this.modalBoton = "Publicar"
      } else if(accion =="modificar") {
        this.modalTexto = "Desea grabar los datos de la Solicitud?"
        this.modalTitulo = "Confirmar modificacion de la Solicitud"
        this.modalBoton = "Grabar"
      }
    },
    confirmarAccionModal() {
      window.scrollTo(0,0);
      this.modalShow = !this.modalShow
      if(this.publicar  == true) {
        this.save(this.solicitudInformacion,"PUBLICADO")
      } else if (this.publicar == false){
        this.save(this.solicitudInformacion,"BORRADOR")
      }
    },

    save: async function (instance,estado) {
      this.listaContactos = (await HTTP.get('/solicitudInformacion/contacto/listar/',{ params: {solicitudId: this.id}})).data
      console.log(this.listaContactos.length>0)
      if(this.listaContactos.length>0){
        if(this._checkPerfil('rfi_convocante_admin')){
          if(typeof(sessionStorage.getItem("uoc")) !== 'undefined' || sessionStorage.getItem("uoc")!== null)
            instance.unidad_contratacion_id = sessionStorage.getItem("uoc")
          instance.origen_rfi = "CONVOCANTE"
        } else if(this._checkPerfil('rfi_convenio_admin')){
          instance.unidad_contratacion_id = null
          instance.origen_rfi = "CONVENIO"
        }
        instance.estado_codigo = estado;
        instance.recepcion_propuesta_fecha_fin = this.concatDateTime(instance.recepcion_propuesta_fecha_fin,instance.recepcion_propuesta_hora_fin)
        instance.reunion_informativa_fecha = this.concatDateTime(instance.reunion_informativa_fecha,instance.reunion_informativa_hora)
        instance.adjuntos = this.archivoList
        try {
          const data = await (HTTP.post('/solicitudInformacion/modificar', instance));
          await this.getArchivos(); //Se recupera la metadata de archivos asociados
          window.scrollTo(0,0);
          if(instance.estado_codigo == "BORRADOR") {
            this.$root.$emit('showNotificationSuccess', {mensaje: 'Se ha modificado la Solicitud de Informacion'});
          }
          else if(instance.estado_codigo == "PUBLICADO") {
            this.$root.$emit('showNotificationSuccess', {mensaje: 'Se ha publicado la Solicitud de Informacion'});
            this.tipo = "";
            this.mensaje = "";
          }
          this.solicitudInformacion = (await HTTP.get('/solicitudInformacion/',{ params: {solicitudId: this.id}})).data
          this.separarFechaHora()
          console.log(data);
        } catch (error) {
          this.$root.$emit('showNotificationError', {mensaje: 'Ocurrio un error al modificar la Solicitud de Informacion'});
          console.log(error);
        }
        window.scrollTo(0,0);
      }else {
        window.scrollTo(0, 0);
        this.$root.$emit('showNotificationError', {mensaje: 'Se Debe agregar al menos un contacto'});
      }
      window.scrollTo(0, 0);

    },

    cambiar_estado: async function (estado,instance) {
      if(typeof(sessionStorage.getItem("uoc")) !== 'undefined' || sessionStorage.getItem("uoc")!== null)
        instance.unidad_contratacion_id = sessionStorage.getItem("uoc")
      instance.estado_codigo = estado;
      
      instance.recepcion_propuesta_fecha_fin = this.concatDateTime(instance.recepcion_propuesta_fecha_fin,instance.recepcion_propuesta_hora_fin)
      instance.reunion_informativa_fecha = this.concatDateTime(instance.reunion_informativa_fecha,instance.reunion_informativa_hora)
      try {
        const data = await (HTTP.post('/solicitudInformacion/modificar', instance));
        await this.getArchivos(); //Se recupera la metadata de archivos asociados
        window.scrollTo(0,0);
        this.$root.$emit('showNotificationSuccess', {mensaje: 'Se ha cambiado el estado de la Solicitud de Informacion'});
        console.log(data);
      } catch (error) {
        this.$root.$emit('showNotificationError', {mensaje: 'Ocurrio un error al cambiar el estado la Solicitud de Informacion'});
        console.log(error);
      }
    },

    volver: function () {
      this.$router.push({path: "/"})
    },
    async getArchivos() {
      this.archivoList = (await HTTP.get('/archivo/listar', {params: {solicitudId: this.id}})).data;
    },
    cargarArchivo: function () {
      let formData = new FormData()
      formData.append('archivo', this.archivo)
      this.cargaArchivo = true;
      HTTP.post('/archivo/subir', formData, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'multipart/form-data'
        },
      }).then(result => {
        let tmpAdjunto = {
          tmpFilePath: result.data.tmpFilePath,
          nombre_archivo: this.archivo.name,
          fecha_archivo: (new moment).format('YYYY-MM-DD HH:mm:ss'),
          rfi_id: this.id
        }
        this.archivoList.push(tmpAdjunto)
        this.$root.$emit('showNotificationSuccess', {mensaje: 'Archivo recibido correctamente'});
        this.archivo = null
      }).catch(error => {
        window.scrollTo(0,0);
        this.$root.$emit('showNotificationError', {mensaje: 'Ocurrio un error al subir el archivo. ' + error.response.data});
      }).finally(() => {
        this.cargaArchivo = false;
      })
    },
    obtenerArchivo(instance) {
      console.log("descargar", instance)
      HTTP.put('/archivo/obtenerArchivo', instance, {responseType: 'blob'})
      .then(result => {
        this.handleResponseArchivo(result.data, instance.nombre_archivo)
      })
      .catch(error => {
        this.$root.$emit('showNotificationError', {mensaje: 'Ocurrio un error al Obtener el archivo. ' + error.response.data});
      })
    },
    borrarArchivo: function (instance) {
      // this.$delete(this.archivoList, index)
      HTTP.post(`/archivo/eliminar`, instance)
      .then(async result => {
        console.log(result)
        window.scrollTo(0,0);
        this.$root.$emit('showNotificationSuccess', {mensaje: 'Archivo eliminado correctamente'});
        await this.getArchivos(); // Se actualiza la lista de archivos
      })
      .catch(error => {
        console.log(error)
        window.scrollTo(0,0);
        this.$root.$emit('showNotificationError', {mensaje: 'Ocurrio un error al Borrar el archivo'});
      })
    },
    handleResponseArchivo(blobData, name) {
      let fileURL = window.URL.createObjectURL(blobData);
      let fileLink = document.createElement("a");
      fileLink.href = fileURL;
      fileLink.setAttribute("download", `${name}`);
      document.body.appendChild(fileLink);
      fileLink.click();
      fileLink.remove();
    },

    agregarContacto: function () {
      this.contacto = {};
      this.contactoModal = true ;
    },

    modificarContacto: async function (row, index) {
      this.contactoModal = true ;
      this.contacto= row;
      this.indexModificado = index;
    },


    grabarContacto: async function (instance) {
      instance.rfi_id = this.id
      console.log(instance)
      this.contactoModal = false ;

      if(!this._checkRequired(instance, this.requiredFieldsContacto)){
        window.scrollTo(0, 0);
        this.$root.$emit('showNotificationWarning', {mensaje: 'Debe ingresar minimamente los campos de Cargo y Correo'});
      } else {
        try {
          if (this.indexModificado == null) {
            await (HTTP.post('/solicitudInformacion/contacto/create', instance));
            this.listaContactos = (await HTTP.get('/solicitudInformacion/contacto/listar/',{ params: {solicitudId: this.id}})).data
            window.scrollTo(0, 0);
            this.$root.$emit('showNotificationSuccess', {mensaje: 'Contacto modificado correctamente'});
            this.limpiarContacto()
          } else {
            await (HTTP.put('/solicitudInformacion/contacto/modificar', instance));
            this.listaInvitados = (await HTTP.get('/solicitudInformacion/contacto/listar/' + this.id)).data
            this.limpiarContacto()
          }
        } catch (error) {
          //this.notificar('error', this.title, error.response.data.message)
        }
      }

    },

    limpiarContacto: function () {
      this.contactoModal = false ;
      this.contacto= {};
      this.indexModificado = null;
    },

    borrarContacto: async function (instance){
      try {
        await HTTP.put(`/solicitudInformacion/contacto/eliminarContacto/${instance.id}`, instance);
        this.listaContactos = (await HTTP.get('/solicitudInformacion/contacto/listar/',{ params: {solicitudId: this.id}})).data
        window.scrollTo(0, 0);
        this.$root.$emit('showNotificationSuccess', {mensaje: 'Contacto eliminado correctamente'});
      } catch (error) {
        switch (error.response.status) {
          case 404:
            window.scrollTo(0, 0);
            this.$root.$emit('showNotificationSuccess', {mensaje: 'Contacto eliminado correctamente'});
            this.listaInvitados = {}
            break;
          case 500:
            console.log('500 error');  // or here
            break;
          default:
            break;
        }
      }
    },

    concatDateTime: function (fecha, hora){
      var momentObj = moment(fecha + hora, 'YYYY-MM-DDLT');
      return momentObj.format('YYYY-MM-DD HH:mm:ss');
    },


  }
}
</script>

<style scoped>


</style>
